"use strict";
var btnAppendRow = document.querySelector(".append-row");
var btnRemoveRow = document.querySelector(".remove-row");
var btnAppendColumn = document.querySelector(".append-column");
var btnRemoveColumn = document.querySelector(".remove-column");
function updateButtons() {
    var table = document.querySelector("tbody");
    var rowCount = table.rows.length;
    var columnCount = rowCount > 0 ? table.rows[0].cells.length : 0;
    btnAppendRow.disabled = rowCount >= 10;
    btnRemoveRow.disabled = rowCount <= 2;
    btnAppendColumn.disabled = columnCount >= 10;
    btnRemoveColumn.disabled = columnCount <= 2;
}
btnAppendRow.addEventListener("click", function() {
    var table = document.querySelector("tbody");
    if (table.rows.length < 10) {
        var value = table.rows[0].cells.length;
        var newRow = document.createElement("tr");
        for(var i = 0; i < value; i++){
            var newTd = document.createElement("td");
            newRow.append(newTd);
        }
        table.append(newRow);
        updateButtons();
    }
});
btnAppendColumn.addEventListener("click", function() {
    var table = document.querySelector("tbody");
    var columnCount = table.rows[0].cells.length;
    if (columnCount < 10) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                var newTd = document.createElement("td");
                row.append(newTd);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        updateButtons();
    }
});
btnRemoveRow.addEventListener("click", function() {
    var table = document.querySelector("tbody");
    if (table.rows.length > 2) {
        table.lastElementChild.remove();
        updateButtons();
    }
});
btnRemoveColumn.addEventListener("click", function() {
    var table = document.querySelector("tbody");
    var columnCount = table.rows[0].cells.length;
    if (columnCount > 2) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                row.lastElementChild.remove();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        updateButtons();
    }
});
updateButtons();

//# sourceMappingURL=index.0bc55fe3.js.map
